class EnvironmentService {
  constructor() {}

  getBaseAPI() {
    return process.env.REACT_APP_API_URL;
  }

  getServiceAPI() {
    return process.env.REACT_APP_SERVICE_URL;
  }
}

export default EnvironmentService;
